import React, { Component } from 'react'
import Activity from "framework/containers/Activity"
import FormAction from 'app/modules/Accounting/reports/PaymentReport/APReportPaymentAction'

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class APReportPaymentActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/modules/Accounting/reports/PaymentReport/APReportPayment")
	}

	render() {
		return (
			<Activity 
				name="APReportPayment"
				RenderedComponent={this.RenderedComponent}
				context="APReportPayment"
				action="APReportPayment"
				formActions={FormAction}			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(APReportPaymentActivity)
